import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class AreasExpertiseExperience extends _BaseUserProfile {
  component = 'ChipsModalSelect';
  props = {
    title: 'Areas of Expertise and Experience',
    callToAction: '(Select All That Apply to You by Years of Experience)',
    optionsTitle: 'Experience (Yrs.)',
    optionsLabel: 'Select Years',
    itemsTitle: 'Areas',
    errorMessage: 'Please Select Areas of Expertise and Experience',
  };
}
